<script setup>
/* Die Statussymbole sind handgezeichnet und Teil der Identität der App —
   es gibt keine Standardsymbole, die dasselbe aussagen. Pfade unverändert
   aus der ursprünglichen statusIcon()-Funktion übernommen. */
defineProps({
  status: { type: String, required: true },
});
</script>

<template>
  <span class="status-chip" :class="status">
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <template v-if="status === 'camp'">
        <circle cx="12" cy="12" r="9" fill="#2ED191" />
        <path
          d="M8 12.5l2.5 2.5L16 9.5"
          stroke="#04120C"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </template>

      <template v-else-if="status === 'trial'">
        <path d="M3 11l18-8-8 18-2-8-8-2z" fill="#E3AE5C" />
      </template>

      <template v-else-if="status === 'nt'">
        <path d="M6 3v18" stroke="#5FA8E0" stroke-width="2" stroke-linecap="round" />
        <path d="M6 4h11l-2.2 3.2L17 10.5H6z" fill="#5FA8E0" />
      </template>

      <template v-else-if="status === 'injured'">
        <circle cx="12" cy="12" r="9" fill="#E2685A" />
        <rect x="10.6" y="6.5" width="2.8" height="11" fill="#FFFFFF" />
        <rect x="6.5" y="10.6" width="11" height="2.8" fill="#FFFFFF" />
      </template>

      <template v-else-if="status === 'transferred'">
        <path d="M12 3l7 2.5v5.5c0 4.5-3 8-7 9.5-4-1.5-7-5-7-9.5V5.5L12 3z" fill="#9AA7B2" />
        <path
          d="M8.5 10.3h6M14.3 10.3l-1.8-1.8M14.3 10.3l-1.8 1.8"
          stroke="#111820"
          stroke-width="1.4"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5 14.2h-6M9.7 14.2l1.8-1.8M9.7 14.2l1.8 1.8"
          stroke="#111820"
          stroke-width="1.4"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </template>

      <template v-else-if="status === 'released'">
        <circle cx="12" cy="12" r="9" fill="none" stroke="#E2685A" stroke-width="2.4" />
        <line x1="6" y1="18" x2="18" y2="6" stroke="#E2685A" stroke-width="2.4" />
      </template>
    </svg>
    {{ $t(`status.${status}`) }}
  </span>
</template>
